import { render, staticRenderFns } from "./DarkModeToggle.vue?vue&type=template&id=2b3fccdd&"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js&"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports